// Utility/theme.js

const normalizeColor = (value) => {
  if (typeof value !== "string") return null;

  const color = value.trim();

  // Accept #RGB and #RRGGBB.
  return /^#(?:[\da-f]{3}|[\da-f]{6})$/i.test(color)
    ? color
    : null;
};

export const getThemeFromResponse = (response) => {
  const theme = response?.data?.client?.themeJson?.columnJson;

  return {
    primaryColor: normalizeColor(theme?.primaryColor),
    secondaryColor: normalizeColor(theme?.secondaryColor),
    linkColor : normalizeColor(theme?.linkColor),
  };
};

export const applyTheme = (theme) => {
  const primaryColor = normalizeColor(theme?.primaryColor);
  const secondaryColor = normalizeColor(theme?.secondaryColor);
  const linkColor = normalizeColor(theme?.linkColor);

  if (typeof document === "undefined") return;

  const rootStyle = document.documentElement.style;

  if (primaryColor) {
    rootStyle.setProperty("--primary-color", primaryColor);
  } else {
    rootStyle.removeProperty("--primary-color");
  }

  if (secondaryColor) {
    rootStyle.setProperty("--secondary-color", secondaryColor);
  } else {
    rootStyle.removeProperty("--secondary-color");
  }

  if (linkColor) {
    rootStyle.setProperty("--text-link", linkColor);
  } else {
    rootStyle.removeProperty("--text-link");
  }
};

const THEME_CACHE_KEY = "client-theme";

export const cacheTheme = (theme) => {
  try {
    if (Object.keys(theme || {}).length > 0) {
      localStorage.setItem(THEME_CACHE_KEY, JSON.stringify(theme));
    } else {
      localStorage.removeItem(THEME_CACHE_KEY);
    }
  } catch (e) {}
};

export const applyCachedTheme = () => {
  try {
    const cached = JSON.parse(localStorage.getItem(THEME_CACHE_KEY));
    if (cached) applyTheme(cached);
  } catch (e) {}
};

export const resetTheme = () => {
  applyTheme(null);
  try {
    localStorage.removeItem(THEME_CACHE_KEY);
  } catch (e) {}
};